import { render } from "./route-view2.vue?vue&type=template&id=37d13bb2"
import script from "./route-view2.vue?vue&type=script&lang=ts"
export * from "./route-view2.vue?vue&type=script&lang=ts"
script.render = render

export default script